import React from 'react'

import {
  FieldSpec,
  PaginatedTable,
  RelatedLinkedField,
  RelatedListValueField,
  ValueField,
} from 'src/components/Table'
import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { RetailerLabel } from 'src/modules/supply_chain/components/retailers/RetailerLabel'
import { FreightShipmentPallet } from 'src/api/models'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  pallet: { id: 'pallet', label: 'Pallet', renderer: RelatedLinkedField(ValueField, 'name') },
  client: {
    id: 'pallet.client',
    label: 'Client',
    ordering: 'container__pallet__account__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  clientID: {
    id: 'pallet.clientID',
    label: 'Client ID',
    ordering: 'container__pallet__client_uid',
    renderer: ValueField,
  },
  ssccCode: {
    id: 'ssccCode',
    label: 'SSCC',
    ordering: 'sscc_code',
    renderer: ValueField,
  },
  skus: { id: 'pallet.skus', label: 'SKUs', renderer: RelatedListValueField('sku') },
  path: {
    id: 'pallet.path',
    label: 'Path',
    ordering: 'container__place__search_path',
    renderer: ValueField,
  },
  shipment: { id: 'shipment', label: 'Shipment', renderer: RelatedLinkedField(ValueField, 'name') },
}

export const FreightShipmentPalletListTable = (props: ListTableProps) => {
  const { paginator, fields } = props
  const { print, renderPrintComponent } = useAsyncPrint()

  const printLabel = (shipmentPallet: FreightShipmentPallet) => {
    print((props) => <RetailerLabel data={shipmentPallet.labelData} {...props} />)
  }

  return (
    <>
      {renderPrintComponent()}
      <PaginatedTable
        title="Pallets"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        rowActions={[{ title: () => 'Print Retailer Label', onClick: printLabel }]}
      />
    </>
  )
}
